import { useState, useEffect } from "react";
import InputFilter from "../../components/GInput/InputFilter";
import DropDownFilterSearch from "../../components/GDropDownList/DropDownFilterSearch";
import DropDownFilter from "../../components/GDropDownList/DropDownFilter";
import { motion, AnimatePresence } from "framer-motion";
import StateCard from "../sharedUi/stateCard";
import { FaArrowUp } from "react-icons/fa";
import { FaArrowDown } from "react-icons/fa";
import CategoryIcon from '@mui/icons-material/Category';
import { useNavigate } from "react-router-dom";
import i18n from "../../lib/i18n";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { MdCategory } from "react-icons/md";
import { TbCategoryFilled } from "react-icons/tb";
import { RiPagesFill } from "react-icons/ri";
import InventoryIcon from '@mui/icons-material/Inventory';


export default function CategoriesFilter ({categoriesData, statusOfCategories, values, search}) {

    const [value, setValue] = useState({});
    const [visible, setVisible] = useState(true);
    const statisticsData = useSelector((state) => state.statistics.items);
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const t = i18n.t.bind(i18n); 
    const currentLang = i18n.language;

    const handleVisible = () => {
        setVisible(!visible);
    }

    useEffect(() => {

        const updatedValue = values.reduce((acc, item) => ({
            parent_id: item.parent_id || acc.parent_id || "",
            status: item.status || acc.status || "",
            name: item.name || acc.name || "",
        }), {
            parent_id: "",
            status: "",
            name: "",
        });
        
        setValue(updatedValue);
        
    }, [values]);

    const handleValues = (key, v) => {
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;
        searchParams.delete(key);

        const newUrl = `${url.pathname}?${searchParams.toString()}${url.hash}`;
        
        navigate(newUrl, { replace: true });

        setValue(prev => ({
            ...prev,
            [key]: ""
        }));
    };

    return (<>
        <AnimatePresence>
        {visible && (
                <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                    className="grid grid-cols-1 sm:grid-cols-4 gap-6 py-4 mt-4 overflow-hidden"
                >
                {[
                    {
                    title: "No. Categories",
                    value: statisticsData[0]?.count_main_categories,
                    subtitle: "All Analytics",
                    icon: <MdCategory className="text-white" size={18} />,
                    iconBg: "bg-blue-700"
                    },
                    {
                    title: "No. Sub Categories",
                    value: statisticsData[0]?.count_sub_categories,
                    subtitle: "All Analytics",
                    icon: <TbCategoryFilled className="text-white" size={18} />,
                    iconBg: "bg-blue-700"
                    },
                    {
                    title: "No. Blogs",
                    value: statisticsData[0]?.count_blogs,
                    subtitle: "All Analytics",
                    icon: <RiPagesFill className="text-white" size={18} />,
                    iconBg: "bg-blue-600"
                    },
                    {
                    title: "No. Packages",
                    value: statisticsData[0]?.count_packages,
                    subtitle: "All Analytics",
                    icon: <InventoryIcon className="text-white" fontSize='medium' />,
                    mui: true,
                    iconBg: "bg-blue-600"
                    },
                ].map((card, idx) => (
                    <motion.div
                    key={idx}
                    initial={{ rotateY: 90, opacity: 0 }}
                    animate={{ rotateY: 0, opacity: 1 }}
                    exit={{ rotateY: 90, opacity: 0 }}
                    transition={{ duration: 0.6, ease: "easeInOut", delay: idx * 0.1 }}
                    className="w-full"
                    style={{ transformStyle: "preserve-3d" }}
                    >
                    <StateCard {...card} />
                    </motion.div>
                ))}
                </motion.div>
        )}
        </AnimatePresence>
        <div className=" bg-thirdly rounded-t-lg px-5 py-3">
            <div className="py-2 flex flex-row justify-between items-center">
                <p className="text-[22px] text-left font-semibold text-white">{currentLang === "en" ? "Filters" : "الفلاتر"}</p>
                {visible ? <FaArrowUp className="text-gray-300 text-xl cursor-pointer bg-furthly p-1 rounded-sm" onClick={handleVisible} /> : <FaArrowDown className="text-gray-300 text-xl cursor-pointer bg-secondary p-1 rounded-sm" onClick={handleVisible} />}
            </div>
            <div className="flex sm:flex-row flex-col justify-center items-center pt-2 pb-4 gap-8">
                <div className="w-full">
                    <DropDownFilterSearch search={search} options={categoriesData} value={value.parent_id} defaultText={t("filters.category")} paramkey="parent_id" />
                </div>
                <div className="w-full">
                    <DropDownFilter options={statusOfCategories} value={value.status} defaultText={t("filters.category_type")} paramkey="status" />
                </div>
                <div className="w-full">
                    <InputFilter placeholder={t("filters.name")} icon={<CategoryIcon fontSize="small" className="text-white" />} type={"text"} paramkey="name"/>
                </div>
            </div>
            <div className="flex flex-row flex-wrap justify-end items-center gap-5">
                {Object.entries(value).map(([key, v]) => ( 
                    v != "" && <div className="bg-gray-600 text-white flex justify-between items-center gap-3 rounded-lg text-md px-3 py-[2px]"><button onClick={() => handleValues(key, v)} className="bg-red-500 w-4 h-4 rounded-full text-sm text-white text-bold flex justify-center items-center">X</button> {key}: {String(v)} </div>
                ))}
            </div>
        </div>
    </>)
}